const article = {
  state: {
    // 搜索关键词
    searchKey:''
  },
  actions: {},
  mutations: {
    UPDATE_ARTICLE_SEARCHKEY(state, data) {
      state.searchKey = data
    },
  }
}

export default article